import styled from 'styled-components';

const MainPage = styled.div`
	display: flex;
	width: 100%;
`;

export default MainPage;
